import { ICompany } from "bets.oddprovider.lib.common.ts/models"
import { NumberUtils } from "fwork-jsts-common/src"
import { ApiClientUtils } from "fwork-jsts-common/src/apiClient"
import { FilterQuery } from "mongoose"
import { useSnackbar } from "notistack"
import React, { useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { DEFAULTGAP, RoutesNames } from "../../globals"
import { ICompaniesState, companiesStateLoadFromApi } from "../../redux/reducers/companies.slice"
import { toggleLoading } from "../../redux/reducers/loadingBar.slice"
import { RootState } from "../../redux/store"
import { HeaderComponent } from "../common/header"
import { SearchInputComponent } from "../common/searchInput"
// import { TableComponent } from '../common/table'
// import { StyledListItemText, StyledTableCell, TableComponentClickRowProps, TableComponentSetCurrPageProps } from '../common/table/common'
import { StyledListItemText, StyledTableCell, TableComponent, TableComponentSetCurrPageProps } from 'fwork.react.apptemplate'

export const CompaniesComponent = () => {
  const tableComponentSetCurrPageRef = useRef<TableComponentSetCurrPageProps>(() => { });
  const tableComponentSetCurrPage = tableComponentSetCurrPageRef.current

  const navigate = useNavigate()
  const dispatch = useDispatch<any>()
  const { enqueueSnackbar } = useSnackbar()
  const [searchText, setSearchText] = useState<string | undefined>()

  const companiesState: ICompaniesState = useSelector((state: RootState) => state.companiesState)
  const companies = [...companiesState.payload || []]

  const loadCompanies = async () => {
    dispatch(toggleLoading())
    const where: FilterQuery<ICompany> | undefined = searchText ? {
      $or: [
        {
          name: { $regex: searchText, $options: 'i' }
        },
        {
          id: NumberUtils.onlyNumbers(searchText)
        }]
    } : undefined

    const response = await dispatch(companiesStateLoadFromApi({
      where,
      onFinally: () => {
        dispatch(toggleLoading())

        if (tableComponentSetCurrPage)
          tableComponentSetCurrPage({
            page: 0
          })
      },
      onError: (msg) => {
        enqueueSnackbar(ApiClientUtils.getErrorMessage(msg), { variant: 'error' })
      }
    }))

    if (!response.payload?.data?.payload?.length) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage('Nenhum registro encontrado'), { variant: 'warning' })
    }
  }

  return <>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      paddingBottom: DEFAULTGAP
    }}>
      <HeaderComponent
        props={{
          style: {
            paddingInline: DEFAULTGAP
          }
        }}
        title='Empresas'
        onRefreshClick={loadCompanies}
        onAddClick={() => navigate(RoutesNames.company)}
      />

      <SearchInputComponent
        style={{
          marginInline: DEFAULTGAP,
          maxWidth: 500
        }}
        label='Pesquisar por nome ou código'
        onChange={e => setSearchText(e.target.value)}
        onKeyUp={e => { if (e.key === "Enter") loadCompanies() }}
        onIconClick={loadCompanies}
      />

      <TableComponent
        wrapperProps={{ style: { padding: DEFAULTGAP, maxWidth: 'calc(100% - 10px)' } }}
        setCurrPageRef={tableComponentSetCurrPageRef}
        bodyList={companies}
        bodyRowBuilder={(company: ICompany) => {
          return <StyledTableCell>
            <StyledListItemText
              primary={company.name}
            />
          </StyledTableCell>
        }}
        rowProps={{
          onClickGetItem: (event: React.MouseEvent<HTMLTableRowElement, MouseEvent>, item: ICompany) => {
            navigate(RoutesNames.company.replace(':id', item?.id.toString()))
          }
        }}
      />

    </div>
  </>
}